import { render, staticRenderFns } from "./ResidueGenerator.vue?vue&type=template&id=7497cb22&scoped=true"
import script from "./ResidueGenerator.vue?vue&type=script&lang=js"
export * from "./ResidueGenerator.vue?vue&type=script&lang=js"
import style0 from "./ResidueGenerator.vue?vue&type=style&index=0&id=7497cb22&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7497cb22",
  null
  
)

export default component.exports